export default __webpack_public_path__ + "static/media/node2.553e10b2.jpeg";